// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custom-slider[data-v-08c6d844]{display:flex;cursor:grab;scroll-behavior:initial}@media only screen and (max-width: 768px){.custom-slider[data-v-08c6d844]{scroll-behavior:smooth}}.custom-slider[data-v-08c6d844]::-webkit-scrollbar{display:none}.custom-slider .custom-slide[data-v-08c6d844]{user-select:none;cursor:grab}.custom-slider .custom-slide[data-v-08c6d844] img{pointer-events:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
